import { productSubscribe } from "./back-in-stock";
import { productSlider } from "./sliders/product-slider";
import "./product-recommended";

const $doc = $(document);

productColorVariants();
productSlider();

$doc.on("submit", ".form-back-in-stock", function(e) {
  e.preventDefault();

  productSubscribe($(this));
});

$doc.on("change", "#product-select", function() {
  const $this = $(this);
  const $option = $this.find("option:selected");
  const $productContent = $this.closest(".product__content");
  const $productPrice = $productContent.find(".product__price");
  const $button = $productContent.find("#add");
  const $backInStockLink = $productContent.find(".back-in-stock");
  const priceData = $option.data("price");
  const variantAvailable = $option.attr("disabled") ? false : true;

  $productPrice.html(priceData);

  if (variantAvailable) {
    $button
      .text(Shopify.theme.locale.products.product.add_to_cart)
      .removeClass("disabled");
    $backInStockLink.addClass("hidden");
  } else {
    $button
      .text(Shopify.theme.locale.products.product.sold_out)
      .addClass("disabled");
    $backInStockLink.removeClass("hidden");
  }
});

$doc
  .on("change", ".list-radios:not(.field-color) input", function() {
    changeProductVariant($(this));
  })
  .on("change", ".field-color input", function(e) {
    const $this = $(this);
    const $swatches = $(".section-product .list-radios.field-color").html();

    handleColorChange($this, $swatches);
  });

// Browser history back button
window.onpopstate = function(event) {
  if ($(".template-product").length) {
    history.replaceState(window.location.pathname, {}, event.state);
    history.back();
  }
};

function productColorVariants() {
  let tag = $(".product--single").data("tag");

  if (tag !== undefined) {
    const url = `/collections/all/style%3A${tag}?view=html`;

    $.ajax({
      method: "GET",
      url: url
    }).done(function(response) {
      window.colorProducts = $(response).find(".product");
      const currentColor = $(".field-color input:checked").val();
      const allColors = getColorSwatches(currentColor);

      $(".list-radios.field-color").html("");
      allColors.forEach(color => {
        $(".list-radios.field-color").append(color);
      });
      $(".list-radios.field-color").addClass("loaded");
    });
  }
}

function changeProductVariant($this) {
  const selector = getVariantSelector($this);
  const $productSelect = $("#product-select");

  $productSelect
    .find(`option${selector}`)
    .prop("selected", true)
    .trigger("change");
}

/**
 * Builds color swatches based on products
 *
 * @param   {jQuery collection}  $products  jQuery collection of all the products that should be used for the swatches
 *
 * @return  {html}          List of all the color swatches
 */
function getColorSwatches(currentColor) {
  const allColors = [];

  window.colorProducts.each(function() {
    const $this = $(this);
    const $currentColor = $this.find(".list-radios.field-color li");
    const $input = $currentColor.find("input");

    if ($input.val() == currentColor) {
      $input.attr("checked", true);
    }

    allColors.push($currentColor);
  });

  return allColors;
}

/**
 * Handles the change between colors on PDP
 *
 * @return  {}  No return data
 */

function handleColorChange($color, $swatches) {
  const selectedProductId = $color.attr("id");
  const selectedSize = $(
    ".section-product .list-radios:not(.field-color) input:checked"
  ).val();
  const $sizeGuide = $(".section-product #shopify-section-size-guide").html();
  const $bradcrumbs = $(".section-product .breadcrumbs").html();
  let updatedSize = "";
  let $product;

  $(".selector-wrapper").remove();

  window.colorProducts.each(function() {
    const $this = $(this);

    if ($this.attr("id") === selectedProductId) {
      $product = $this;
    }
  });

  const $productHolder = $(".section-product .shell").html($product);
  const productHandle = $productHolder.find(".product--single").data("handle");

  history.pushState(window.location.pathname, {}, productHandle);

  $productHolder.find("#shopify-section-size-guide").html($sizeGuide);
  $productHolder.find(".breadcrumbs").html($bradcrumbs);

  $productHolder
    .find(".list-radios.field-color")
    .html($swatches)
    .addClass("loaded")
    .find(`input`)
    .attr("checked", false)
    .closest(".list-radios.field-color")
    .find(`input[value="${$color.val()}"]`)
    .attr("checked", true);

  if (selectedSize) {
    setTimeout(() => {
      const $productSelect = $productHolder.find("#product-select");
      const variantSelector = getVariantSelector($color);
      const $selectedOption = $productSelect.find(`option${variantSelector}`);
      const $backInStockLink = $productHolder.find(".back-in-stock");
      const variantAvailable = $selectedOption.attr("disabled") ? false : true;

      variantAvailable
        ? $backInStockLink.addClass("hidden")
        : $backInStockLink.removeClass("hidden");

      if ($productHolder.find(`input[value="${selectedSize}"]`).length) {
        updatedSize = selectedSize;
      } else if (
        $productHolder.find(`input[value="${selectedSize.toLowerCase()}"]`)
          .length
      ) {
        updatedSize = selectedSize.toLowerCase();
      } else {
        updatedSize = selectedSize.toUpperCase();
      }

      $productHolder
        .find(".list-radios:not(.field-color) input")
        .attr("checked", false)
        .closest(".list-radios")
        .find(`input[value="${updatedSize}"]`)
        .trigger("click");
    }, 10);
  }

  $(".slider--product .slick-initialized").length == 0
    ? productSlider()
    : productSlider(true);

  if (
    $productHolder
      .find(`.list-radios:not(.field-color) input[value="${selectedSize}"]`)
      .closest(".radio")
      .hasClass("radio--disabled")
  ) {
    $productHolder.find(".back-in-stock").removeClass("hidden");
  } else {
    $productHolder.find(".back-in-stock").addClass("hidden");
  }
}

/**
 * Returns data-string selector
 *
 * @param   {jQuery element}  $optionChanged  Changed element
 *
 * @return  {String}                  Selector with all selected variant options
 */
function getVariantSelector($optionChanged) {
  const $selectedOptions = $optionChanged
    .closest(".form__body")
    .find("input:checked");
  let selector = "";

  $selectedOptions.each(function() {
    const $this = $(this);
    const optionName = $this.closest(".list-radios").data("option");

    selector += `[data-${optionName}="${$this.data("value")}"]`;
  });

  return selector;
}
